export default __webpack_public_path__ + "static/media/Group1183.25f904a3.svg";